module.exports = __webpack_public_path__ + "img/08219203001157.8de0b9c6.png";